import { render } from "./App.vue?vue&type=template&id=040fa464"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Eren\\Desktop\\TAŞINACAKLAR\\VueApp\\Vue Project\\link-crop\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__